// The development-only shortcut panel, shared by /register and /forgot.
//
// On a dev box with no SendGrid or Twilio credentials the senders log to the
// console instead of sending, so a signup or a password reset can be started and
// never finished without reading the API's terminal. The server hands the
// verification back in the response when — and only when — it is non-production
// AND that channel is genuinely unconfigured, and this renders it.
//
// ⚠ These values are the real verification secrets. The panel is deliberately
// loud and deliberately ugly so it can never be mistaken for ordinary page
// furniture. A production server cannot set the fields that reach here; the
// labelling is for the day somebody is looking at a screen and cannot tell which
// box they are on.

import { el } from '../dom.js';

export interface DevShortcut {
  /** A link to follow straight through — the verify or reset URL. */
  url?: string | undefined;
  /** A short code to type instead, where there is no link (SMS). */
  code?: string | undefined;
  /** Link text, since "verification" and "reset" are different words. */
  linkText: string;
}

/** Returns an empty array when the server sent nothing, so it spreads inline. */
export function devPanel(shortcut: DevShortcut): HTMLElement[] {
  const { url, code, linkText } = shortcut;
  if (!url && !code) return [];
  return [
    el('div', { class: 'dev-panel' }, [
      el(
        'p',
        { class: 'dev-panel-tag' },
        'Development only: no mail or SMS provider is configured',
      ),
      url
        ? el('p', {}, [el('a', { href: url }, linkText)])
        : el('p', {}, ['Verification code: ', el('strong', {}, code!)]),
    ]),
  ];
}
